// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
// RxJS
import {Observable, of} from 'rxjs';
import { tap } from 'rxjs/operators';
import {AuthService} from '../ngrx/main/auth.service';

@Injectable(
	{
		providedIn: 'root' // il permet d'ajouter ce guard dans les providers 'global' de l'app
	}
)
export class AuthGuard implements CanActivate {
	constructor(private router: Router, private authService: AuthService) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>  {
		const estConnect: Observable<boolean> = of(this.authService.estConnecte());
		return estConnect.pipe(
			tap((_estConnect: boolean) => {

				if(!_estConnect){
					this.router.navigateByUrl('/auth/login').then();
					return false
				}
				return true
			})
		);
	}
}
